import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';

export enum EPurchasesRoute {
  purchases = 'purchases',
  orders = 'orders',
  view = 'view',
  receptions = 'receptions',
  receptionView = 'receptionView',
}

CamRoutes.addRoute({
  key: EPurchasesRoute.purchases,
  url: 'purchases',
  children: [
    {
      key: EPurchasesRoute.orders,
      url: 'orders',
    },
    {
      key: EPurchasesRoute.view,
      url: 'view/:id',
    },
    {
      key: EPurchasesRoute.receptions,
      url: 'receptions',
    },
    {
      key: EPurchasesRoute.receptionView,
      url: 'receptions/view/:id',
    },
  ],
});

export const purchasesRoutes: Routes = [
  {
    path: '',
    redirectTo: CamRoutes.getUrl([EPurchasesRoute.purchases, EPurchasesRoute.orders]),
    pathMatch: 'full',
  },
  {
    path: CamRoutes.getUrl([EPurchasesRoute.purchases, EPurchasesRoute.orders]),
    loadComponent: () => import('./pages/purchases/orders/orders.component').then(c => c.OrdersPage),
  },
  {
    path: CamRoutes.getUrl([EPurchasesRoute.purchases, EPurchasesRoute.receptions]),
    loadComponent: () => import('./pages/purchases/receptions/receptions.component').then(c => c.ReceptionsPage),
  },
  {
    path: CamRoutes.getUrl([EPurchasesRoute.purchases, EPurchasesRoute.view]),
    loadComponent: () =>
      import('./pages/purchases/view/purchase-order-details.component').then(c => c.PurchaseOrderDetailsPage),
  },
  {
    path: CamRoutes.getUrl([EPurchasesRoute.purchases, EPurchasesRoute.receptionView]),
    loadComponent: () =>
      import('./pages/purchases/receptions/view/reception-details.component').then(c => c.ReceptionDetailsPage),
  },
];
